import { render, staticRenderFns } from "./ItemNew.vue?vue&type=template&id=2fa51732&scoped=true&"
import script from "./ItemNew.vue?vue&type=script&lang=js&"
export * from "./ItemNew.vue?vue&type=script&lang=js&"
import style0 from "./ItemNew.vue?vue&type=style&index=0&id=2fa51732&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa51732",
  null
  
)

export default component.exports